import __request__ from 'routing/request';
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface AzureLogsRequestImpl {
    readonly azure_event_hub_name: string;
    readonly azure_proxy_options: string;
    readonly azure_consumer_group: string;
    readonly azure_connection_string: unknown;
    readonly azure_enable_proxy: boolean;
}
interface AzureLogsCreateInputRequest {
    readonly azure_event_hub_name: string;
    readonly enable_proxy: boolean;
    readonly azure_batch_size: number;
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly azure_consumer_group: string;
    readonly azure_connection_string: unknown;
    readonly azure_wait_time: number;
    readonly name: string;
    readonly store_full_message: boolean;
    readonly proxy_options: string;
    readonly polling_interval: number;
    readonly enable_throttling: boolean;
}
/**
 * Validate input credentials
 */
export function checkCredentials(JSONbody: AzureLogsRequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.azure.api.AzureLogsResource/azure_logs/checkCredentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new Azure Logs input
 */
export function create(JSONbody: AzureLogsCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.azure.api.AzureLogsResource/azure_logs/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
